import { call, put, select } from 'redux-saga/effects';
import { addItemRequest, getItemsRequest, updateItemRequest } from '../../spItems/api';
import { VPORequirementsConditionsListName } from 'src/api/config';
import { getActionsData, getActionsDataSuccess } from '../actions';
import { getDefaultSaga } from './getDefaultSaga';
import { actionsVPO, VPOInconsistences } from 'src/pages/DashboardPage/vpo/api/vpo.config';
import { myTaskActionsListName } from 'src/api/config/myTasksActions.config';
import { actionsStatus } from 'src/api/config/systemSwitch';

export function* getActionsDataSaga({ payload }: any) {
  try {
    if (payload) {
      const { groupRequirements, departments, groupRequirementID, groupIds, FactoryID } = payload;

      console.log('payload', payload);

      // let groupRequirementIDs = {};

      // groupIds.map((groupId: any) => {
      //   groupRequirementIDs = {
      //     [groupId]: {
      //       actionsResponse: {
      //         items: []
      //       }
      //     }
      //   }
      // })

      // console.log('actionsResponse', groupIds.map((groupId: any) => '*'+groupId), FactoryID);

      const actionsResponse: unknown = yield call<any>(getDefaultSaga, {
        listName: actionsVPO,
        filters: { 
          ColumnBlockID: groupIds.map((groupId: any) => ''+groupId),
          FactoryID: ''+FactoryID
        },
      });

      // console.log('actionsResponse', actionsResponse);

      let idsActions: any = [];

      if(
        actionsResponse &&
        actionsResponse.items &&
        actionsResponse.items.length > 0
      ){
        actionsResponse.items.map((item) => {
          idsActions.push(item.ID);
        })
      }

      let inconsistencesResponse = null,
          idsInconsistences: any = [];

      // console.log('idsActions', idsActions);

      if(
        idsActions &&
        idsActions.length > 0
      ){

        console.log('idsActions', idsActions);

        //! Разбивка массив idsActions на части по 20 элементов
        const chunkSize = 20;
        const allInconsistencies: any[] = [];

        for (let i = 0; i < idsActions.length; i += chunkSize) {
          const chunk = idsActions.slice(i, i + chunkSize);
          const chunkResponse: any = yield call<any>(getDefaultSaga, {
            listName: VPOInconsistences,
            filters: { IdVPOactions: chunk },
          });

          if (chunkResponse?.items) {
            allInconsistencies.push(...chunkResponse.items);
          }
        }

        inconsistencesResponse = { items: allInconsistencies };

        // console.log('inconsistencesResponse', inconsistencesResponse);

        if(
          inconsistencesResponse &&
          inconsistencesResponse.items &&
          inconsistencesResponse.items.length > 0
        ){
          inconsistencesResponse.items.map((item) => {
            idsInconsistences.push(`*#VPO_${item.ID}`);
          })
        }

      }

      let planListResponse = null;

      if(
        inconsistencesResponse &&
        idsInconsistences &&
        idsInconsistences.length > 0
      ){
        //! Разбивка массив на части по 20 элементов для избежания слишком длинных URL
        const chunkSize = 20;
        const allItems: any[] = [];

        for (let i = 0; i < idsInconsistences.length; i += chunkSize) {
          const chunk = idsInconsistences.slice(i, i + chunkSize);
          const chunkResponse: any = yield call<any>(getDefaultSaga, {
            listName: myTaskActionsListName,
            filters: {
              ImportantHashTag: chunk,
              Status: [actionsStatus.notStart, actionsStatus.process, actionsStatus.old]
            },
          });

          if (chunkResponse?.items) {
            allItems.push(...chunkResponse.items);
          }
        }

        planListResponse = { items: allItems };
      }

      let groupRequirementIDs: any = {};

      // console.log('props', {
      //   planListResponse,
      //   actionsResponse,
      //   inconsistencesResponse
      // })

      if(
        planListResponse &&
        planListResponse.items &&
        planListResponse.items.length > 0 &&
        actionsResponse &&
        actionsResponse.items &&
        actionsResponse.items.length > 0 && 
        inconsistencesResponse &&
        inconsistencesResponse.items &&
        inconsistencesResponse.items.length > 0
      ){
        actionsResponse.items.map((action: any) => {

          let is_task = false;

          // let listTasks = [];
          let groupId = action.ColumnBlockID;

          let filter_inconsistences = inconsistencesResponse.items.filter(el => (''+el.IdVPOactions).indexOf(action.ID) >= 0);
          if(
            filter_inconsistences &&
            filter_inconsistences.length > 0
          ){
            filter_inconsistences.map((incon: any) => {
              let filter_tasks = planListResponse.items.filter(el => el.ImportantHashTag.indexOf(`#VPO_${incon.ID}`) >= 0)
              if(
                filter_tasks &&
                filter_tasks.length > 0
              ){
                is_task = true;
              }
            })
          }

          if(is_task){
            if(groupRequirementIDs[groupId]){
              groupRequirementIDs = {
                ...groupRequirementIDs,
                [groupId]: {
                  actionsResponse: {
                    items: [
                      ...groupRequirementIDs[groupId].actionsResponse.items,
                      action
                    ]
                  }
                }
              }
            } else {
              groupRequirementIDs = {
                ...groupRequirementIDs,
                [groupId]: {
                  actionsResponse: {
                    items: [action]
                  }
                }
              }
            }
          }

        });
      }

      // console.log('groupRequirementIDs', groupRequirementIDs);

      yield put(
        getActionsDataSuccess({
          // actionsResponse: {
          //   items: listIssetTasks
          // },
          inconsistencesResponse,
          planListResponse,
          groupRequirementID,
          groupRequirementIDs
        })
      );
    }
  } catch (error) {
    console.log(error);
  }
}
